import React, { useEffect, useRef, useState } from 'react'
import { Navigate } from 'react-router-dom'
import authService from '../../services/auth.service';
import { useDispatch, useSelector } from 'react-redux';

const PrivateRoute = ({ children }) => {
    
  const dispatch = useDispatch();
  
  useEffect(() => {
     authService.getUser(dispatch);
  }, []);
    
        const studentInformation = useSelector((state) => state.auth.studentData);
    
      const contentRef = useRef(null);
    
        const [paymentStatus,setpaymentStatus] = useState("")
        
      useEffect(() => {
          if (!studentInformation || !Array.isArray(studentInformation.transactions) || studentInformation.transactions.length === 0) {
            setpaymentStatus("Pending");
          } else {
            setpaymentStatus(studentInformation.transactions[studentInformation.transactions.length - 1]);
          }
        }, [studentInformation]);



    const isLoggedIn = localStorage.getItem("auth_token")

    if(!isLoggedIn){
        return <Navigate to="/student/login" replace/>
    }

   


    return children
}

export default PrivateRoute